import * as Api from '@ViewModels';
import { ContactFilterOption } from '../../../components/automation/AutomationStepCard/components/ContactFilterOption';
import { useAutomationFlowContext } from '../contexts/AutomationFlowContext';

interface ConditionalFilterProps {
	stepId: string;
	filter: Api.IContactsFilterRequest | null | undefined;
	canEdit: boolean;
	isBusy?: boolean;
	onFilterChange: (filter: Api.IContactsFilterRequest | null) => void;
}

/**
 * Shared component for displaying and editing conditional contact filters.
 * Used across multiple automation step renderers (Email, Texting, ActionItem, etc.)
 * to allow skipping steps based on contact criteria.
 */
export function ConditionalFilter({ stepId, filter, canEdit, isBusy, onFilterChange }: ConditionalFilterProps) {
	const { impersonationContext } = useAutomationFlowContext();

	return (
		<ContactFilterOption
			canEdit={canEdit}
			impersonationContext={impersonationContext}
			skipStepContactFilter={filter}
			stepUuid={stepId}
			stepIsBusy={isBusy || false}
			onFilterChange={onFilterChange}
		/>
	);
}
